import React from "react";
import { Alert, Button } from "antd";
import { Link } from "react-router-dom";

function UnpaidInvoiceMessage({ count }) {
  if (!count || count <= 0) return null;

  return (
    <Alert
      message={`شما ${count} فاکتور پرداخت‌نشده دارید.`}
      type="warning"
      banner
      showIcon
      style={{ width: "100%", marginBottom: "30px" }}
      action={
        <Button size="small" danger>
          <Link to="/invoices">مشاهده فاکتورها</Link>
        </Button>
      }
    />
  );
}

export default UnpaidInvoiceMessage;
